export type TrapFocusCleanup = () => void;

export const trapFocus = ({
  el,
  notFiltering,
  forceAutofocusEl
}: {
  el: JQuery<HTMLElement>;
  notFiltering?: boolean;
  forceAutofocusEl?: JQuery<HTMLElement>
}): (() => void) => {
  const focusableSelector = 'select:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), button:not([tabindex="-1"]), a:not([tabindex="-1"])';

  const getTabbableElements = () => {
    if (notFiltering) {
      return el.find(focusableSelector);
    } else {
      return el
        .find(focusableSelector)
        .filter(':not([aria-hidden="true"]):not(.hidden):visible');
    }
  };

  const container = el[0];

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key !== 'Tab' || !container) return;

    const tabbable = getTabbableElements();

    if (tabbable.length === 0) return;

    const firstTabbable = tabbable[0] as HTMLElement;
    const lastTabbable = tabbable[tabbable.length - 1] as HTMLElement;
    const activeElement = document.activeElement;

    // Si le focus n'est pas dans le conteneur, le ramener au premier élément
    if (!container.contains(activeElement)) {
      e.preventDefault();
      firstTabbable.focus();
      return;
    }

    if (e.shiftKey) {
      if (activeElement === firstTabbable) {
        e.preventDefault();
        lastTabbable.focus();
      }
    } else {
      if (activeElement === lastTabbable) {
        e.preventDefault();
        firstTabbable.focus();
      }
    }
  };

  document.addEventListener('keydown', handleKeyDown);

  if (forceAutofocusEl) {
    forceAutofocusEl.trigger('focus');
  } else {
    const tabbable = getTabbableElements();
    if (tabbable.length > 0) {
      (tabbable[0] as HTMLElement).focus();
    }
  }

  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
};
